import React, { useState, useEffect } from 'react'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { ERR_MSG_404_TEMPLETE_ID } from '../../../constants/msgText'
import AppendixSettingWidget from '../../../widgets/projectProposal/appendix/AppendixSettingWidget'
import { getSettingFormProjectAppendix } from '../../../redux/actions/subProjectFormSetting'
import { TEMP_FORM_ID } from '../../../constants/constants'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import ContentHeaderWidget from '../../../components/ContentHeader/ContentHeaderWidget'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'

export default function AppendixSetting(props) {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const formId = sessionGetItemStr(TEMP_FORM_ID)

  useEffect(() => {
    if (formId) {
      handleGetSchema()
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_TEMPLETE_ID,
      })
    }
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSettingFormProjectAppendix(formId)
      // const _schema = mockSchema
      setSchema(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isNewSubProjectSetting>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isNewSubProjectSetting>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isNewSubProjectSetting>
          <ContentHeaderWidget header={schema.header} subHeader={schema.subHeader} />

          {schema.buttonRoute && <BtnEditAll routing={schema.buttonRoute} hiddenBtnEdit />}

          {schema?.forms?.appendix && <AppendixSettingWidget schema={schema.forms.appendix} />}
        </SidebarProposal>
      )}
    </>
  )
}
